import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import React, {  useState } from 'react'
import AutoCompleteMultiSelect from '../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import TextAreaComponents from '../../components/TextAreaComponents/TextAreaComponents.tsx'
import StickyHeadTable from '../../components/SpecificationTable/Specification.tsx'
import DetailsTable from '../../components/SpecificationTable/DetailsTable.tsx'
import { ToastContainer, toast } from 'react-toastify'
import CustomDataGrid from '../../components/CustomDataGrid/CustomDataGrid.tsx'
import arrowUp from './../../../assets/icons/arrowup.png'
import arrowDown from './../../../assets/icons/arrowDown.png'
import ediPencil from './../../../assets/icons/editPencil.png'
import EditDetailsTable from '../../components/SpecificationTable/EditDetailsTable.tsx'
import axios from 'axios';


function Details(props) {
  console.log(props)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [nameProps, setNameProps] = useState('')
  const [Rank, setRank]=useState()
  const[Id, setId]=useState()
  const [descriptionProps, setDescriptionProps] = useState('')
  const[NameErr, setNameErr]=useState(false)
  const[DescriptionErr, setDescriptionErr]=useState(false)
  const[testState, setTestState]=useState(false)

const [DefaultDetailsData, setDefaultDetailsData]=useState()
const [OpenFromData, setOpenFromData]=useState()
const [TempDefaultData, setTempDefaultData]=useState([])
const [rows, setRows]=useState([])
console.log(DefaultDetailsData)

  const handleName = (props) => {
    setName(props)
    setNameErr(false)
  }

  const handleDescription = (props) => {
    setDescription(props)

    setDescriptionErr(false)
  }

const getDataToEdit=(id,name,description,rank)=>{
  console.log(id,name,description,rank)
  setId(id)
  setDescription(description)
  setName(name)
  setRank(rank)
}
// React.useEffect(()=>{
//   console.log('c')
//   console.log(TempDefaultData)
//   if(TempDefaultData!=undefined){
//     console.log('d')
//     setDefaultDetailsData(TempDefaultData)
//   }
  
// },[testState])

React.useEffect(()=>{
  setDefaultDetailsData(props.defaultData)
  setOpenFromData(props.openFrom)
  console.log(props.openFrom)
  console.log(props.defaultData)
},[props.defaultData, props.openFrom])

React.useEffect(()=>{
  console.log(OpenFromData)
},[OpenFromData])

const getTabledata=(tableData)=>{
  console.log(tableData)
  setRows(tableData)
  // setDefaultDetailsData(tableData)
}
const[loading, setLoading]=React.useState(0)
const apiAddress = process.env.REACT_APP_SECRET;

  const handleSave = () => {

    // if(props.openFrom=='AddItem'){
    //   console.log('this add items details')
    // }
    // else if(props.openFrom=='EditItem'){
    //   console.log('this Edit items details')
    // }

    // <DetailsTable  />
    setLoading(1)
    var valid=true
    if((name=="" && description!="") || (name!="" && description==""))
    {
      valid=false
      toast.error("One or more filed is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",

    })
    }
    if(!!name==false){
      valid=false
      setNameErr(true)
    }
    if(!!description==false){
      valid=false
      setDescriptionErr(true)
    }
    if(valid && props.openFrom=='AddItem'){
      console.log('details save from add')
      if(!!Id==false){
        setNameProps(name)
        setDescriptionProps(description)
        setName('')
        setDescription('')
      }
      }
      else if(valid && props.openFrom=='EditItem'){
        if(!!Id==false){
        setNameProps(name)
        setDescriptionProps(description)
        setName('')
        setDescription('')

        var detailsInsertObj={
          id: "123",
          foodItemId: props.FooditemId,
          details: name,
          description: description,
          rankOrder: 1,
          creationId: "string"
        }

        var url = apiAddress + "/api/FoodItems/InsertFoodItemDetailFromEdit?alsoForLinked=false";

        axios.post(url, detailsInsertObj).then((response) => {
          console.log(response.data);
          //SetloadingModal(false);
          toast.success("Details Inserted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        console.log('details save from edit')
        }
        else{
        console.log('details update from Edit')
        console.log(props.FooditemId)
        var data=[...rows]
        console.log(data)
        var obj=data.find(x=>x.id==Id)
        console.log(obj)
        obj.details=name
        obj.description=description
        console.log(obj)

        var detailsUpdateObj={
          id: obj.id,
          foodItemId: props.FooditemId,
          details: obj.details,
          description: obj.description,
          rankOrder: obj.rankOrder,
          creationId: "string"
        }
        console.log(detailsUpdateObj)

        var url = apiAddress + "/api/FoodItems/FoodItemDetailsUpdate?DetailsId=" +obj.id;

        axios.put(url, detailsUpdateObj).then((response) => {
          console.log(response.data);
          //SetloadingModal(false);
          toast.success("Details Updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setDefaultDetailsData([])
          loadDetailsData(props.FooditemId)
          setName('')
          setDescription('')
          setId('')
          setRank('')
        });
        }

      }
      
    }
    const loadDetailsData = async (props) => {
      if (props != undefined) {
        const response = await axios.get(
          apiAddress +
            "/api/FoodItems/GetFoodItemDetailsByFoodItemId?Id=" +
            props
        );
        console.log(response.data);
        setDefaultDetailsData(response.data)
      }
    }
    
    //setLoading(0)




  return (
    <div>
      {/* <ToastContainer /> */}
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid xs={2}>
          <Typography style={{ paddingTop: '1rem' }}>Name</Typography>
        </Grid>
        <Grid xs={10}>
          <TextAreaComponents
            label={'Item name'}
            value={handleName}
            val={name}
          />
          {NameErr && <span style={{color:'red'}}>This field is required</span>}
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid xs={2}>
          <Typography style={{ paddingTop: '1rem' }}>Description</Typography>
        </Grid>
        <Grid xs={10}>
          <TextAreaComponents
            id={1}
            label={'Description'}
            value={handleDescription}
            val={description}
          />
        {DescriptionErr && <span style={{color:'red'}}>This field is required</span>}
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid item xs={11}></Grid>
        <Grid item xs={1}>
          <Button onClick={handleSave}>
            Save
          </Button>
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid item xs={2}></Grid>
        <Grid item xs={10}>
          {/* {!DefaultDetailsData==false &&
          <DetailsTable Name={nameProps} Description={descriptionProps} sendToAddItem={props.sendToAddItem} />
           } */}
          
      {/* {loading==1?('loading'):( */}
           { DefaultDetailsData? (
            <EditDetailsTable
             Id={Id} 
             Name={nameProps} 
             Description={descriptionProps} 
             Rank={Rank} 
             sendToDetails={getTabledata}
             sendToAddItem={props.sendToAddItem} 
             defaultData={DefaultDetailsData} 
             sendForEdit={getDataToEdit}
             openFrom={props.openFrom}
             />
            ):(
              <DetailsTable Name={nameProps} Description={descriptionProps} sendToAddItem={props.sendToAddItem} openFrom={props.openFrom} />
            )
          }
          
          
        </Grid>
      </Grid>


    </div>
    // <>
    //   <Paper sx={{ width: '100%', overflow: 'hidden' }}>
    //     <TableContainer sx={{ maxHeight: 440 }}>
    //       <Table stickyHeader aria-label="sticky table">
    //         <TableHead>
    //           <TableRow>
    //             {columns.map((column) => (
    //               <TableCell
    //                 key={column.id}
    //                 align="left"
    //                 style={{ minWidth: column.minWidth }}
    //               >
    //                 {column.label}
    //               </TableCell>
    //             ))}
    //           </TableRow>
    //         </TableHead>
    //         <TableBody>
    //           {rows
    //             .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    //             .map((row, index) => (
    //               <TableRow hover role="checkbox" tabIndex={-1} key={row.name}>
    //                 <TableCell>{row.rank}</TableCell>
    //                 <TableCell>{row.name}</TableCell>
    //                 <TableCell>{row.description}</TableCell>
    //                 <TableCell>
    //                   <button
    //                     disabled={index === 0}
    //                     onClick={() => handleRankChange(index, 'decrease')}
    //                   >
    //                     Decrease
    //                   </button>
    //                   <button
    //                     disabled={index === rows.length - 1}
    //                     onClick={() => handleRankChange(index, 'increase')}
    //                   >
    //                     Increase
    //                   </button>
    //                 </TableCell>
    //               </TableRow>
    //             ))}
    //         </TableBody>
    //       </Table>
    //     </TableContainer>
    //     <TablePagination
    //       rowsPerPageOptions={[10, 25, 100]}
    //       component="div"
    //       count={rows.length}
    //       rowsPerPage={rowsPerPage}
    //       page={page}
    //       onPageChange={handleChangePage}
    //       onRowsPerPageChange={handleChangeRowsPerPage}
    //     />
    //     <form onSubmit={handleFormSubmit}>
    //       <input
    //         type="text"
    //         placeholder="Name"
    //         value={name}
    //         onChange={(event) => setName(event.target.value)}
    //       />
    //       <input
    //         type="text"
    //         placeholder="Description"
    //         value={description}
    //         onChange={(event) => setDescription(event.target.value)}
    //       />
    //       <button type="submit">Add Row</button>
    //     </form>
    //   </Paper>
    // </>
  )
}

export default Details
